import { useEffect, useState } from "react";
import { useNotification } from "../../toster-notification/NotificationContext";
import { useParams } from "react-router-dom";
import Loader from "../../shared/Loader";
import { LiveOrdersPickUpItemListDTO } from "../../../models/order/order.response";
import { orderService } from "../../../services/orderService";
import { handleErrorNotification } from "../../../utils/errorNotificatioMessage";
import { OrderStatusType, orderStatusTypeToClassName, orderStatusTypeToString } from "../../../models/base/OrderStatusType";
import { ArrowRightGreyIcon, CalendarGreyIcon, ClocckGreyIcon, TelephoneIcon, UserGreyIcon } from "../../../assets/icons";
import { ToLocalDateTimeString } from "../../../utils/dateFormater";
import SideOrderInfo from "../shared/order-list/SideOrderInfo";
import OrderInfoModalView from "../shared/views/modal-view/OrderInfoModalView";
import { connection, startConnection } from "../../../services/signalRConnection";


const LiveOrdersPickUpPage: React.FC = () => {

    const [orders, setOrders] = useState<LiveOrdersPickUpItemListDTO[]>([]);
    const [selectedOrderId, setSelectedOrderId] = useState<string>("");

    const [isOrderInfoModalOpen, setIsOrderInfoModalOpen] = useState<boolean>(false);

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();
    const { localId } = useParams<{ localId: string }>();


    useEffect(() => {
        fetchOrders();
    }, [localId]);

    useEffect(() => {

        const handler = (orderId: string) => {
            fetchOrder(orderId);
        }

        const setup = async () => {
            await startConnection();
            await connection.invoke<void>("JoinOrderPickUpMonitoring", localId);
            connection.on("NewPickUpOrder", handler);
        }

        setup();

        return () => {
            connection.off("NewPickUpOrder", handler);
        }

    }, [localId])

    const fetchOrder = async (orderId: string) => {
        if (!localId) {
            notify("error", "Local ID nije prosleđen");
            return;
        }

        try {
            const response = await orderService.getPickupLiveOrder(localId, orderId);

            if (response.success && response.data) {
                const order = response.data;
                setOrders(prev => [...prev, order]);
            } else {
                notify("error", "Greška pri učitavanju porudžbina", response.message || "Došlo je do greške pri učitavanju porudžbina.");
            }
        } catch (error: any) {
            notify("error", "Greška pri učitavanju porudžbina", "Došlo je do greške pri učitavanju porudžbina.");
            handleErrorNotification(error, notify);
        }
    };


    const fetchOrders = async () => {
        if (!localId) {
            notify("error", "Local ID nije prosleđen");
            return;
        }

        setLoading(true);
        try {
            const response = await orderService.getPickupLiveOrders(localId);

            if (response.success && response.data) {
                setOrders(response.data);
            } else {
                notify("error", "Greška pri učitavanju porudžbina", response.message || "Došlo je do greške pri učitavanju porudžbina.");
            }
        } catch (error: any) {
            notify("error", "Greška pri učitavanju porudžbina", "Došlo je do greške pri učitavanju porudžbina.");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };


    if (loading) {
        return <Loader />;
    }

    return (
        <>
            {isOrderInfoModalOpen && (
                <OrderInfoModalView
                    selectedOrderId={selectedOrderId}
                    onClose={() => {
                        setIsOrderInfoModalOpen(false)
                        fetchOrders();
                    }}
                />
            )}

            <section className="live-order-view1-section pickup-orders">
                <div className="w-layout-blockcontainer container live-order-main w-container">
                    <div className="live-order-main-wrapper">
                        <div className="tables-status-layout">

                            <div className="lo-status-list orders-list">
                                <div className="admin-settings-box-div live-orders-info">
                                    <div className="lo-status-header-div">
                                        <div>Poručeno</div>
                                    </div>
                                    <div className="lo-status-block">
                                        <div className="lo-status-point-info ordered"></div>
                                        <div>{orders.filter(order => order.currentStatus === OrderStatusType.Ordered).length}</div>
                                    </div>
                                </div>
                                <div className="admin-settings-box-div live-orders-info">
                                    <div className="lo-status-header-div">
                                        <div>Primljeno</div>
                                    </div>
                                    <div className="lo-status-block">
                                        <div className="lo-status-point-info recived"></div>
                                        <div>{orders.filter(order => order.currentStatus === OrderStatusType.Recived).length}</div>
                                    </div>
                                </div>
                                <div className="admin-settings-box-div live-orders-info">
                                    <div className="lo-status-header-div">
                                        <div>Usluženo</div>
                                    </div>
                                    <div className="lo-status-block">
                                        <div className="lo-status-point-info served"></div>
                                        <div>{orders.filter(order => order.currentStatus === OrderStatusType.Served).length}</div>
                                    </div>
                                </div>
                                <div className="admin-settings-box-div live-orders-info">
                                    <div className="lo-status-header-div">
                                        <div>Račun</div>
                                    </div>
                                    <div className="lo-status-block">
                                        <div className="lo-status-point-info bill"></div>
                                        <div>{orders.filter(order => order.currentStatus === OrderStatusType.Bill).length}</div>
                                    </div>
                                </div>
                                <div className="admin-settings-box-div live-orders-info">
                                    <div className="lo-status-header-div">
                                        <div>Plaćeno</div>
                                    </div>
                                    <div className="lo-status-block">
                                        <div className="lo-status-point-info paid"></div>
                                        <div className="text-block-16">{orders.filter(order => order.currentStatus === OrderStatusType.Paid).length}</div>
                                    </div>
                                </div>
                                <div id="w-node-e3767345-47bf-2fa2-75fa-6bda1b7e3a97-1cee91cf" className="admin-settings-box-div live-orders-info">
                                    <div className="lo-status-header-div">
                                        <div>Otkazano</div>
                                    </div>
                                    <div className="lo-status-block">
                                        <div className="lo-status-point-info cancelled"></div>
                                        <div>{orders.filter(order => order.currentStatus === OrderStatusType.Cancelled).length}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="lo-orders-list-div">

                                {orders.length === 0 ? (
                                    <div className="no-orders-div">
                                        <div className="no-orders-text">Nema aktivnih porudžbina za preuzimanje.</div>
                                    </div>
                                ) : (
                                    orders.map((order) => (

                                        <div
                                            className={`admin-settings-box-div order-list-item ${orderStatusTypeToClassName(order.currentStatus)}`}
                                            key={order.id}
                                            onClick={() => setSelectedOrderId(order.id)}
                                        >
                                            <div className="lo-order-item-div">
                                                <div>
                                                    <div className="div-block-63 top-div">
                                                        <div>#{order.id.slice(0, 8)}</div>
                                                        <div className={`small-box-div order-status ${orderStatusTypeToClassName(order.currentStatus)}`}>
                                                            {orderStatusTypeToString(order.currentStatus)}
                                                        </div>
                                                    </div>
                                                    <div className="div-block-63">
                                                        <div className="div-block-64">
                                                            <img src={CalendarGreyIcon} loading="lazy" alt="" className="icon-size-16" />
                                                            <div className="description-text">{ToLocalDateTimeString(order.pickUpAt.toString())}</div>
                                                        </div>
                                                        <div className="div-block-64">
                                                            <img src={UserGreyIcon} loading="lazy" alt="" className="icon-size-16" />
                                                            <div className="description-text">{order.fullName}</div>
                                                        </div>
                                                        <div className="div-block-64">
                                                            <img src={TelephoneIcon} loading="lazy" alt="" className="icon-size-16" />
                                                            <div className="description-text">{order.phoneNumber}</div>
                                                        </div>
                                                        <div className="div-block-64">
                                                            <img src={ClocckGreyIcon} loading="lazy" alt="" className="icon-size-16" />
                                                            <div className="description-text">{ToLocalDateTimeString(order.createdAt.toString())}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="div-block-65">
                                                    <div className="div-block-66">
                                                        <div className="lo-order-list-item-price">{order.totalPrice} RSD</div>
                                                        <div className="description-text">{order.itemsCount} stavki</div>
                                                    </div>
                                                    <img src={ArrowRightGreyIcon} loading="lazy" alt="" className="icon-size-20 align-center"
                                                        onClick={() => {
                                                            setSelectedOrderId(order.id);
                                                            setIsOrderInfoModalOpen(true);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    ))
                                )}

                            </div>
                        </div>

                        <SideOrderInfo
                            selectedOrderId={selectedOrderId}
                            onStatusChange={fetchOrders}
                            listItemOrder={true}
                        />

                    </div>
                </div >
            </section >
        </>
    );
};

export default LiveOrdersPickUpPage;